export const BASIC_USER_ROLE = 'basic_user';
export const USER_ROLE = 'user';
export const ADVANCED_READONLY_USER_ROLE = 'advanced_readonly_user';
export const ADVANCED_USER_ROLE = 'advanced_user';
export const ADMIN_ROLE = 'admin';
